import { render, staticRenderFns } from "./PrintPkgTicketAutoP.vue?vue&type=template&id=01cc00b2&scoped=true&"
import script from "./PrintPkgTicketAutoP.vue?vue&type=script&lang=js&"
export * from "./PrintPkgTicketAutoP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc00b2",
  null
  
)

export default component.exports